import { render, staticRenderFns } from "./cosIndex.vue?vue&type=template&id=5ef3e581&scoped=true"
import script from "./cosIndex.vue?vue&type=script&lang=js"
export * from "./cosIndex.vue?vue&type=script&lang=js"
import style0 from "./cosIndex.vue?vue&type=style&index=0&id=5ef3e581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef3e581",
  null
  
)

export default component.exports